import { formatISO } from "date-fns";
import { HjorteviltJaktdataV1JaktdagSharedJaktdagResponse } from "~/src/api/generated";
import { JaktdagRegistrationDataElg } from "~/src/pages/Registrering/Jaktdag/RegistrerElg/ElgTypes";
import { JaktdagRegistrationDataHjort } from "~/src/pages/Registrering/Jaktdag/RegistrerHjort/HjortTypes";

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export const parseErrors = (errorMessage: string): string => {
  const errorMessages = errorMessage.split("\n");
  const formattedErrors: string[] = errorMessages.map((msg) => {
    let form = msg.trim();
    if (form.endsWith(",")) {
      return form.slice(0, -1);
    } else return form;
  });
  if (formattedErrors.length > 0) return Array.from(new Set(formattedErrors)).join("\n");
  return errorMessage;
};

export const identifierForJaktdag = (
  jaktdag:
    | JaktdagRegistrationDataElg
    | JaktdagRegistrationDataHjort
    | HjorteviltJaktdataV1JaktdagSharedJaktdagResponse,
) => {
  const identifier = `${formatISO(jaktdag.Dato ?? "", { representation: "date" })}-${jaktdag.Art}-${
    jaktdag.Jaktfelt
  }-${jaktdag.Jegernummer}`;
  return identifier;
};
